// mocks
import studentsMock from "../mocks/studentsMock.json";
import { api } from "../utils/api";
import UserStore from "../utils/UserStore";

const getStudentById = async id => {
  const res = await api.get(`/ClassDiaryV1/student/${id}/profile`);
  return res.data;
};

const getStudents = async () => {
  return studentsMock;
};

const getGrades = async studentId => {
  const res = await api.get(
    `Academics/student/${studentId}/report-cards-external`,
    {
      params: { filter: { schoolYear: new Date().getFullYear() } }
    }
  );
  return res.data;
};

const getSchedule = async (start, end, studentId) => {
  const res = await api.get(`/Academics/student/schedule/${studentId}`, {
    params: { start, end }
  });
  return res.data;
};

const getOccurrences = async (
  studentId,
  codPerlet,
  codOccurrenceType = undefined,
  codOccurrenceReason = undefined
) => {
  const res = await api.get(`/ClassDiaryV1/student/${studentId}/occurrences`, {
    params: {
      externalData: UserStore.getUserExternalInfo(),
      codPerlet,
      codOccurrenceType,
      codOccurrenceReason
    }
  });
  return res.data;
};

export default {
  getStudentById,
  getStudents,
  getGrades,
  getSchedule,
  getOccurrences
};
